import { Pipe, PipeTransform } from '@angular/core';
import { getBoatPrice } from 'app/content-result/category-result/result/base-result/information/categories/boat-result/boat-result-functions';

@Pipe({
  name: 'priceFilter'
})
export class PriceFilterPipe implements PipeTransform {
  transform(array: any, lowPrice: number, highPrice: number, category: string): any {
    if (!array || (lowPrice === null && highPrice === null)) {
      return array;  // No hay precio para filtrar, devuelve el array sin cambios.
    }

    switch(category) {
      case '1':
      case '4':
        // Filtramos los hoteles según el precio mínimo y máximo de las habitaciones
        return array.filter((hotel: any) => {
          // Filtrar habitaciones dentro del rango de precios
          const validRooms = hotel.additionalInfo.rooms.filter((room: any) =>
            room.room.optionNightsNetTotalProf >= lowPrice && room.room.optionNightsNetTotalProf <= highPrice
          );

          // Si existen habitaciones válidas dentro del rango, lo incluimos en el resultado
          return validRooms.length > 0;
        });
      case '6':
         // Filtramos los hoteles según el precio mínimo y máximo de las habitaciones
        return array.filter((experience: any) => {
          // Filtrar habitaciones dentro del rango de precios
          const validExperience = experience.additionalInfo.tours.options.filter((experience: any) =>
            experience?.totalPrice >= lowPrice && experience?.totalPrice <= highPrice
          );

          // Si existen habitaciones válidas dentro del rango, lo incluimos en el resultado
          return validExperience.length > 0;
        });
      case '8':
         // Filtramos los hoteles según el precio mínimo y máximo de las habitaciones
        return array.filter((transfer: any) => {
          // Filtrar habitaciones dentro del rango de precios
          const validRooms = transfer.vehicles.filter((vehicle: any) =>
            vehicle?.totalPriceProf >= lowPrice && vehicle?.totalPriceProf <= highPrice
          );

          // Si existen habitaciones válidas dentro del rango, lo incluimos en el resultado
          return validRooms.length > 0;
        });
      case '5':
        // Filtramos los vuelos según el precio total del pasajero principal
        return array.filter((flight: any) => {
          const price = flight?.passengers?.[0]?.price?.total ?? flight?.price?.total;
          return price != null && price >= lowPrice && price <= highPrice;
        });
      case '10':
        // Filtramos los seguros según el precio mínimo y máximo de las opciones de cobertura
        return array.filter((result: any) => {
          const validInsurances = (result.insurances || []).filter((insurance: any) =>
            insurance?.plan?.totalPriceProf >= lowPrice && insurance?.plan?.totalPriceProf <= highPrice
          );

          return validInsurances.length > 0;
        });
      case '3':
        return array.filter((boat: any) => {
          const price = getBoatPrice(boat);
          return price >= lowPrice && price <= highPrice;
        });
    }

  }
}
